import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Cubic } from 'gsap'

import Cover from 'src/components/cover-img'

import resize from 'src/utils/resize'
import values from 'src/values'

export default class ImgItem extends Component {
  constructor(props) {
    super(props)

    this.sizes = {
      desktop: { w: 300, h: 300 }
    }

    this.key = `imgItem${Math.random()}`
  }

  componentDidMount() {
    this.onResize()

    resize.add(this.onResize, this.key)
  }

  componentWillUnMount() {
    resize.remove(this.onResize)
  }

  onResize = () => {
    if (!this.refs.component) return

    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth
  }

  onClick = () => {
    window.open(this.props.data.full_url, '_blank')
  }

  render() {
    const { image } = this.props.data

    return (
      <div
        onClick={this.onClick}
        ref="component"
      className="component img-item-mobile">
        <div ref="mainWrapper" className="img-item-container">
          <div ref="imgContainer" className="img-container">
            <img
              className="insta"
              src={`${process.env.PUBLIC_URL}/img/insta.png`}
            />
            <Cover ref="cover" src={image} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/wall/components/wall-wrapper-mobile/components/img-item/index.js